import { store } from "../state";

const BACK_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>`;

function toLocalInputValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function renderEditEvent(root: HTMLElement): () => void {
  // First run goes through views/onboarding.ts instead; this is the
  // edit form for an existing countdown.
  const existing = store.getPrimaryEvent();

  const defaultTarget = new Date();
  defaultTarget.setDate(defaultTarget.getDate() + 30);
  defaultTarget.setHours(9, 0, 0, 0);

  root.innerHTML = `
    <div class="subscreen">
      <div class="subscreen-header">
        <a class="back-btn" href="#/" aria-label="Back">${BACK_SVG}</a>
        <div class="subscreen-title">Edit the countdown</div>
      </div>
      <form class="field-group" data-el="form">
        <div class="field">
          <label for="f-name">Event name</label>
          <input id="f-name" name="name" type="text" placeholder="Stag Do" maxlength="60" required autocomplete="off" />
        </div>
        <div class="field">
          <label for="f-person">Person's name</label>
          <input id="f-person" name="personName" type="text" placeholder="Dan" maxlength="60" autocomplete="off" />
          <div class="hint">Who it's for, or who's dragging you into it.</div>
        </div>
        <div class="field">
          <label for="f-start">Start date</label>
          <input id="f-start" name="startDate" type="datetime-local" required />
          <div class="hint">When the wait began — powers the progress bar. Defaults to today.</div>
        </div>
        <div class="field">
          <label for="f-date">End date &amp; time</label>
          <input id="f-date" name="targetDate" type="datetime-local" required />
          <div class="hint">Has to be in the future — that's the whole app.</div>
        </div>
        <button class="btn btn-primary" type="submit" data-el="submit">Save changes</button>
      </form>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('[data-el="form"]')!;
  const nameInput = form.querySelector<HTMLInputElement>("#f-name")!;
  const personInput = form.querySelector<HTMLInputElement>("#f-person")!;
  const startInput = form.querySelector<HTMLInputElement>("#f-start")!;
  const dateInput = form.querySelector<HTMLInputElement>("#f-date")!;
  const submitBtn = form.querySelector<HTMLButtonElement>('[data-el="submit"]')!;

  if (existing) {
    nameInput.value = existing.name;
    personInput.value = existing.personName;
    startInput.value = toLocalInputValue(new Date(existing.startDate));
    dateInput.value = toLocalInputValue(new Date(existing.targetDate));
  } else {
    startInput.value = toLocalInputValue(new Date());
    dateInput.value = toLocalInputValue(defaultTarget);
  }

  const nowLocal = toLocalInputValue(new Date());
  dateInput.min = nowLocal;

  function validate() {
    const hasName = nameInput.value.trim().length > 0;
    const start = startInput.value ? new Date(startInput.value).getTime() : NaN;
    const end = dateInput.value ? new Date(dateInput.value).getTime() : NaN;
    const hasDates = Boolean(start) && Boolean(end) && end > Date.now() && end > start;
    submitBtn.disabled = !(hasName && hasDates);
  }
  validate();
  form.addEventListener("input", validate);

  function onSubmit(e: Event) {
    e.preventDefault();
    const name = nameInput.value.trim();
    const personName = personInput.value.trim();
    const start = new Date(startInput.value).getTime();
    const end = new Date(dateInput.value).getTime();
    if (!name || !end || end <= Date.now() || end <= start) return;
    store.saveEvent(
      { name, personName, targetDate: new Date(end).toISOString(), startDate: new Date(start).toISOString() },
      existing?.id
    );
    location.hash = "#/";
  }
  form.addEventListener("submit", onSubmit);

  return () => {
    form.removeEventListener("submit", onSubmit);
    form.removeEventListener("input", validate);
  };
}
